export default __webpack_public_path__ + "static/media/player_2.da19276b.mp3";